module.exports = __webpack_public_path__ + "static/media/video5.52f98bf6.jpg";